<template>
<!--  v-if="permisShow('房源设置')"-->
  <div class='houseSet'>
    <!--第一个div, 上边的，nav -->
      <div class="houseSet_One"  >
        <div v-for="(item,index) in chooseData" :key = "index" >
          <div :class="checkedIndex == index?'houseSet_title1':'houseSet_title2'" @click="chooseShowLoad(index,item)" >
             <p>{{item.functionName}}</p>
          </div>
        </div>
      </div>

    <!--  纠错配置-->
    <Item1 v-if="checkedName === '基础设置'" :tabs="houseData" ref="item2" @chooseShowLoad="chooseShowLoad" class="test"></Item1>
    <Item2 v-if="checkedName === '纠错设置'" :tabs="houseData" ref="item2" @chooseShowLoad="chooseShowLoad" class="test"></Item2>
    <Item5 v-if="checkedName === '完整度匹配'" :tabs="houseData" @saveConfig="saveConfig" humble class="item5"></Item5>
  </div>
</template>

<script>

import {queryBySettingPcode,updateCheckstatusByCodes} from "@/api/systemSetup";
import Item5 from "./houseSetItems/Item5";
import Item2 from "./houseSetItems/Item2";
import Item1 from "./houseSetItems/Item1";

export default {
  name: "houseSet",
  components: { Item5 ,Item2, Item1},
  data(){
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    return {
      permisList,
      chooseData:[],//一级目录
      secondData:[{list:[]},{list:[]}],//二级目录
      checkedIndex:"0",//选中的下标基础设置等
      checkedName:"",//选中的数据（基础设置等）
      houseData:[],
    }
  },
  created() {
    const menu = JSON.parse(localStorage.getItem('menu')) || []
    menu.forEach(item => {
      if (item.name === '系统设置')
        (item.childMenus || []).forEach(childMenu => {
          if (childMenu.name === '房源设置') {
            if(childMenu.show ==true){
              if(childMenu.functions){
                let arrList = []
                childMenu.functions.forEach((item)=>{
                  if(item.show==true){
                    let data = {}
                    data.description = item.description
                    data.functionName = item.functionName
                    arrList.push(data)
                  }
                })
                this.chooseData = arrList
                // console.log(arrList,"arrList")
              }
            }

          }
        })
    })
    // this.pcode = pcode
    // this.getTabsList()
    this.chooseShowLoad(0,this.chooseData[0])
  },
  mounted() {

  },
  methods:{
    //点击主标题
    chooseShowLoad(index,item){
        this.checkedIndex = index
        this.checkedName = item.functionName
        let params = {
          pcode:item.description
        }
        this.$post(queryBySettingPcode,params).then((res)=> {
          if (res.data) {
            this.houseData = res.data
            if(this.checkedName == "纠错设置"){
              this.$refs.item2.getTitleList( this.houseData)
            }
          }
        })
    },

    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },

    saveConfig(list) {
      list.list = JSON.stringify(list.list)
      this.$post(updateCheckstatusByCodes, list).then((res)=>{
        if (res.success) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          // this.chooseShowLoad(1,{description:'02',functionName:'纠错设置'})
        }else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      })
    },
  }
}
</script>

<style lang='less' scoped>
.test{
  margin-left:27px;
  margin-top: 21px;

}
.pColor1{
    color:#5E75E6;
}
.pColor2{
  color:#303133;
}
    .houseSet{
      background: #FFFFFF;
      margin: 14px 16px;
      //overflow: hidden;
      //padding-top:26px
      padding: 22px 30px 10px;
    }
    .houseSet_One{
      display: flex;
      cursor:pointer;
      align-items: center;
      height:36px;

      margin-left:27px;
      //cursor: pointer;

    }
    .houseSet_title1{
      border: 1px solid #E4E7ED;
      height: 36px;
      background-color: #5E75E6;
      //width: 105px;
      >p{
        //width: 55px;
        height: 14px;
        font-size: 14px;
        color: #fff;
        font-weight: 400;
        margin:11px 23px ;
      }
    }

    .houseSet_title2{
      border: 1px solid #E4E7ED;
      height: 36px;
      //width: 105px;
      >p{
        //width: 55px;
        height: 14px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #303133;
        margin:11px 23px ;
      }
    }

    .houseSet_Two{
      cursor:pointer;
      height: 35px;
      background: #EFF2FF;
      margin-left:27px;
      margin-top: 21px;
      display: flex;
      margin-right: 39px;
      position:relative;
    }
    .houseSetTwo_title{
      height: 15px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #303133;
      margin-left: 23px;
      margin-top: 10px;
      //line-height: 42px;
    }
    .houseSetTwo_title2{
      height: 15px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #303133;
      margin-left: 60px;
      margin-top: 10px;
    }
    .houseSet_switch{
      position:absolute; right:10px; top:7px;
    }
    .el-switch__core {
    //!important;
    //  width: 54px;
      height: 23px;
      //background: #3FD27E;
      border-radius: 12px;

    }
    .el-switch__core::after { width: 15px; height: 15px;background: #FFFFFF;
      border-radius: 50%;margin-top: 2px }
    .houseSet_three{
      height: 296px;
      margin-left:27px ;
      margin-right: 39px;
      background: #FFFFFF;
      border: 1px solid #F0F0F0;
      overflow: hidden;
    }
    .houseSet_three_one{
      margin-top: 34px;
    }
    .premises_span{
      width: 64px;
      height: 17px;
      font-size: 16px;
      font-family: Microsoft YaHei ;
      font-weight: 600;
      color:#303133;
      margin-left: 40px;
      //line-height: 42px;
    }
    .houseSet_three_two{
      margin-top: 24px;
      margin-left: 24px;
      width: 68%;
    }
    .houseSet_three_three{
      margin-top: 32px;
    }
    .houseSet_three_four{
      margin-top: 23px;
      margin-left: 24px;
      width: 68%;
    }
    #checkboxList .el-checkbox{
      width: 102px;
    }
     #checkboxList .el-checkbox__inner{
      width: 18px;
      height: 18px;
      border: 1px solid #DCDFE6;
      border-radius: 2px;
    }
    #checkboxList .el-checkbox__inner::after{
      height: 8px;
      left: 5px;
    }
#checkboxList1 .el-checkbox{
  width: 102px;
}
#checkboxList1 .el-checkbox__inner{
  width: 18px;
  height: 18px;
  border: 1px solid #DCDFE6;
  border-radius: 2px;
}
#checkboxList1 .el-checkbox__inner::after{
  height: 8px;
  left: 5px;
}
    .footer_buten{
      font-size: 16px;
      color: white;
      border: none;
      outline: none;
      border-radius: 4px;
      margin-top: 40px;
      float: right;
      margin-right: 39px;
      font-weight: 400;
      &.save {
        width: 100px;
        height: 40px;
        background: #5E75E6;
        border-radius: 4px;
      }
    }
    .checkGroup{
        //margin-left: 84px;
        font-size: 14px;
       font-family: Microsoft YaHei;
        font-weight: 400;
    }

    .item5 {
      margin: 21px 39px 0 27px;
      background: #FFFFFF;
      border: 1px solid #F0F0F0;
    }
</style>